module.exports = __webpack_public_path__ + "img/binance.24d74027.png";